import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import { ability } from '@/common/ability'
import BodyClass from 'vue-body-class'
import { i18n } from '@/plugins/i18n'
import Helpers from '@/plugins/helpers'
import elements from './components/elements'
import {ApiServiceInit, StarShopApiServiceInit} from '@/common/api.service'
import { abilitiesPlugin } from '@casl/vue'
import VueClipboard from 'vue-clipboard2'
import VuePersianDatetimePicker from 'vue-persian-datetime-picker'
import CKEditor from '@ckeditor/ckeditor5-vue2';
import vSelect from 'vue-select'
import TrendChart from "vue-trend-chart";
import mixins from '@/plugins/mixin'

// import styles
import './assets/vendors/global/vendors.bundle.rtl.css'
import './assets/css/style.rtl.css'
import 'vue-select/dist/vue-select.css';



// import vendors
import 'jquery-validation'
import 'bootstrap'
import 'bootstrap-select'


// Load plugins
Vue.use(BodyClass, router)
Vue.use(abilitiesPlugin, ability)
Vue.use(VueClipboard)
Vue.use(Helpers)
Vue.use(CKEditor);
Vue.use(TrendChart);
Vue.use(mixins);

import '@/plugins/layout'
import '@/plugins/vendors'
import '@/plugins/init-app'
import Axios from "axios";


// Persian date picker
Vue.component('datePicker', VuePersianDatetimePicker)
// Vue.component('ckeditor', CKEditor)

// Vue Select
Vue.component('v-select', vSelect)

// load components of elements
elements.init()
// Init api service configs
Axios.defaults.timeout = 150000;
StarShopApiServiceInit()
ApiServiceInit()
StarShopApiServiceInit()
// console.log(store)

Vue.config.productionTip = false
new Vue({
    router,
    i18n,
    store,
    render: h => h(App)
}).$mount('#app')